<template>
  <div v-loading="isLoading" class="basic-ads-campaigns-stats-budget-box">
    <div class="row align-middle basic-ads-campaigns-stats-budget-box__row">
      <div class="columns">
        {{ $t('ADVERTISEMENT.CAMPAIGNS.TODAY_SPENT_BUDGET') }}
      </div>
      <div class="columns shrink">
        <span class="basic-ads-campaigns-stats-budget-box__value">
          {{ formattedTodaySpentBudget }}
        </span>
        <span>
          {{ $t('RIALS') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/number';

export default {
  name: 'CampaignStatsOverallReportsBudget',
  props: {
    isLoading: Boolean,
    spentBudget: {
      type: Number,
      required: true,
    },
    averageSpentBudget: {
      type: Number,
      required: true,
    },
    todaySpentBudget: {
      type: Number,
      required: true,
    },
  },
  computed: {
    formattedSpentBudget() {
      return format(this.spentBudget);
    },
    formattedAverageSpentBudget() {
      return format(this.averageSpentBudget);
    },
    formattedTodaySpentBudget() {
      return format(this.todaySpentBudget);
    },
  },
};
</script>

<style lang="scss">
.basic-ads-campaigns-stats-budget-box {
  width: 100%;

  background-color: #fff;
  border-radius: $lb-border-radius * 5;
  border: 1px solid $lb-light-gray;

  padding: $global-padding * 2.5 $global-padding * 2;

  &__row:not(:first-child) {
    margin-top: $global-margin;
  }

  &__value {
    font-weight: bold;
    font-size: rem-calc(24px);
  }
}
</style>
